import React from "react";

export default function BlackDividerTop() {
  return (
    <div style={{ lineHeight: 0 }}>
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        style={{ width: "100%", height: "80px", display: "block" }}
      >
        <defs>
          <linearGradient id="blackGradientTop" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#0d0d0f" />
            <stop offset="40%" stopColor="#111113" />
            <stop offset="100%" stopColor="#0b0b0c" />
          </linearGradient>
        </defs>

        <polygon
          points="0,0 1440,0 1440,120"
          fill="url(#blackGradientTop)"
        />
      </svg>
    </div>
  );
}